import React from "react";
import { FaLeaf } from "react-icons/fa";

import "../CustomCSS/AboutUs.css";

export default function AboutUs() {
  return (
    <section id="aboutus" className="about-section">
      {/* Rotating Mandala Background */}
      <div
        className="mandala"
        style={{ backgroundImage: "url(/img/mandala-bg.jpg)" }}
      />

      <div className="about-container">
        {/* Circular Image on Left */}
        <div className="about-image">
          <img
            src="/img/aboutus.png"
            alt="Supatham Ayurvedic Hospital"
          />
        </div>

        {/* Content on Right */}
        <div className="about-content">
          <h2>About Us <FaLeaf className="leaf-icon" /></h2>
          <p>
            At <strong>Supatham Ayurvedic Hospital</strong>, we believe true
            healing begins with harmony of the body, mind, and spirit. Inspired
            by the timeless wisdom of Ayurveda, our mission is to provide
            natural, holistic care that nurtures wellness and restores balance.
          </p>
          <p>
            Every treatment is personalized — combining ancient Ayurvedic
            therapies, authentic herbal remedies, and mindful living practices
            to bring lasting health and inner peace.
          </p>

          <div className="about-highlights">
            <div className="highlight-card">🌿 100% Ayurvedic Treatments</div>
            <div className="highlight-card">🪔 Holistic Healing Approach</div>
            <div className="highlight-card">🍃 Herbal Medicines</div>
            <div className="highlight-card">🌸 Wellness & Lifestyle Guidance</div>
          </div>
        </div>
      </div>
    </section>
  );
}
